// angular
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
// app
import { SettingsService } from '../../../_services/api/settings.service';
import { RestResponse } from 'src/app/_shared/models';
import { CompanyNotificationTemplate } from 'src/app/_shared/models/notifications.model';
import { AppAnimations } from 'src/app/_shared/animations';
// other
import Bee from '@mailupinc/bee-plugin';
import template from './BF-basic-standard';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  selector: 'template-editor',
  animations: [AppAnimations],
  host: {'class':'template-editor'},
  styles: [`
    #bee-plugin-container {
      position: relative;
      height: 100%;
    }
  `
  ],

  template: `
    <div [hidden]="!isBePluginStartReady" id="bee-plugin-container"></div>
    <!-- skeleton -->
    <skeleton-loader *ngIf="!isBePluginStartReady" [theme]="{'width': '1024px', 'height': '820px'}"></skeleton-loader>
  `,
})
export class TemplateEditorComponent implements OnInit, OnDestroy {
  beeConfig: any = {
    uid: 'A-S00055291', //needed for identify resources of the that user and billing stuff
    container: 'bee-plugin-container', //Identifies the id of div element that contains BEE Plugin
    language: 'en-US',
    onSave: (_jsonFile, _htmlFile) => {
      console.log('onSave', _jsonFile);
      this.updateEmailTemplate(this._templateId, _jsonFile, _htmlFile);
    },
    onSaveAsTemplate: (_jsonFile) => {
      console.log('onSaveAsTemplate', _jsonFile);
    },
    onSend: (_htmlFile) => {
      console.log('onSend', _htmlFile);
    },
    onError: (_errorMessage) => {
      console.log('onError ', _errorMessage);
    },
  }

  // TODO move to database
  beeClientId = '6d22a725-0050-477f-ab4b-d46f70948c9f';
  beeClientSecret = 'uf18FxLvtHal4dPyk6ILvcvl0XQf6qE2yWza1BAvF7Lv4itofhjU';
  beePlugin = new Bee();
  isBePluginStartReady: boolean = false;
  private subs = new Unsubscriber();

  @Input() _templateId: number;

  constructor(
    private _iconRegistry: MatIconRegistry,
    private _meta: MetaService,
    private _route: ActivatedRoute,
    private _sanitizer: DomSanitizer,
    private settingsService: SettingsService
  ) {
    this._iconRegistry.addSvgIcon('ico-loading', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-loading-01.svg'));
    this._iconRegistry.addSvgIcon('ico-loader', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-loading-01.svg'));
    this._iconRegistry.addSvgIcon('ico-close', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-01.svg'));
  }

  getEmailTemplateById(_templateId: number) {
    this.subs.addSub = this.settingsService.getTemplateByTemplateId(_templateId).subscribe(
        (res: RestResponse) => {
          let emailTemplate = <CompanyNotificationTemplate>res.data,
              contentText = emailTemplate?.contentText,
              templateObj = contentText !== '' && this.validateContentText(contentText) || {};

          // converts fiels int mergeTags, and format then for beeplugin
          this.beeConfig.mergeTags = emailTemplate.fields.map(({name, keyName}) => ({name, value:keyName}));

          this.initializeBeePlugin(
            this.beeClientId,
            this.beeClientSecret,
            this.beeConfig,
            templateObj
          );
        },
        (err: RestResponse) => {
          this._meta.showNotification(err);
        }
      );
  }

  validateContentText(_contentText) {
    try {
      return JSON.parse(_contentText);
    } catch(e) {
      console.error(e);
      console.log('template-editor.component.ts - validateContentText() [ERROR]');
      return {};
    }
  }

  updateEmailTemplate(_templateId, contentText, contentHtml) {
    this.subs.addSub = this.settingsService.updateTemplateByTemplateId(_templateId,{
        contentText,
        contentHtml,
      }).subscribe(
        (res: RestResponse) => {
          this._meta.showNotification(res);
        },
        (err: RestResponse) => {
          this._meta.showNotification(err);
        }
      );
  }

  initializeBeePlugin(_clientId, _clientSecret, _config, _template) {
    this.beePlugin.getToken(_clientId, _clientSecret)
      .then(() => {
        this.beePlugin.start(_config, _template)
          .then(() => {
            this.isBePluginStartReady = true;
        });
      });
  }

  ngOnInit() {
    this.getEmailTemplateById(this._templateId);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
